<template>
  <div class="FullDuplex">
    <div class="title">{{$t('fullDuplex.title1')}}</div>
    <p>{{$t('fullDuplex.p1')}}</p>
    <p>{{$t('fullDuplex.p2')}}</p>
    <div class="imgBox">
      <img :src="require(`@/assets/fullDuplex/${$t('lang') === 'En' ? 'img1-en':'img1'}.png`)" alt="" style="width:90%"/>
      <!-- <img style="width:90%" :src="$t('lang') === 'En' ? require('@/assets/fullDuplex/img2.png'): require('@/assets/fullDuplex/img1.png')"> -->
    </div>
    <div class="title">{{$t('fullDuplex.title2')}}</div>
    <p>{{$t('fullDuplex.p3')}}</p>
    <div class="imgBox">
      <img :src="require(`@/assets/fullDuplex/${$t('lang') === 'En' ? 'img2-en':'img2'}.png`)" alt="" style="width:90%">
    </div>
    <div class="title">{{$t('fullDuplex.title3')}}</div>
    <div class="sub-title">{{$t('fullDuplex.title3_1')}}</div>
    <p>{{$t('fullDuplex.p4')}}</p>
    <div class="imgBox">
      <img :src="require(`@/assets/fullDuplex/${$t('lang') === 'En' ? 'img3-1-en':'img3-1'}.png`)" alt="" style="margin-right:1vw;width:43%">
      <img src="@/assets/fullDuplex/img3-2.png" alt="" style="width:46%">
    </div>
    <div class="imgBox">
      <div style="margin-right:1vw;width:43%">{{$t('fullDuplex.img_des1')}}</div>
      <div style="width:46%">{{$t('fullDuplex.img_des2')}}</div>
    </div>
    <div class="sub-title">{{$t('fullDuplex.title3_2')}}</div>
    <div class="sub-sub-title">{{$t('fullDuplex.title3_2_1')}}</div>
    <p>{{$t('fullDuplex.p5')}}</p>
    <div class="imgBox">
      <img src="@/assets/fullDuplex/img4-1.png" alt="" style="margin-right:1vw;width:39%">
      <img :src="require(`@/assets/fullDuplex/${$t('lang') === 'En' ? 'img4-2-en':'img4-2'}.png`)" alt="" style="width:49.5%">
    </div>
    <div class="imgBox">
      <div style="margin-right:1vw;width:39%">{{$t('fullDuplex.img_des3')}}</div>
      <div style="width:49.5%">{{$t('fullDuplex.img_des4')}}</div>
    </div>
    <p>{{$t('fullDuplex.p6')}}</p>
    <div class="sub-title" style="margin-top:40px">{{$t('fullDuplex.title3_3')}}</div>
    <p>{{$t('fullDuplex.p7')}}</p>
    <div class="imgBox">
      <img src="@/assets/fullDuplex/img5.png" alt="" style="width:90%">
    </div>
    <div class="title">{{$t('fullDuplex.title4')}}</div>
    <p>{{$t('fullDuplex.p8')}}</p>
    <div class="imgBox">
      <img src="@/assets/fullDuplex/img6.png" alt="" style="width:90%">
    </div>
    <div class="title">{{$t('fullDuplex.title5')}}</div>
    <div class="imgBox">
      <img :src="require(`@/assets/fullDuplex/${$t('lang') === 'En' ? 'img7-en':'img7'}.png`)" alt="" style="width:90%">
    </div>
  </div>
</template>

<script>
export default {
  name: "FullDuplex",
};
</script>

<style scoped lang="scss">
.FullDuplex {
  margin-top: 87px;
  padding: 0;
  padding: 0 15vw;
  .title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  p {
    text-indent: 2em;
    font-size: 20px;
    line-height: 30px;
    margin: 0;
    padding: 0;
  }
  .imgBox {
    text-align: center;
    margin: 40px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sub-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  .sub-sub-title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 30px;
    text-indent: 1em;
  }
}
</style>
